import { render } from "./App.vue?vue&type=template&id=a2b46e58"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
script.render = render

export default script